<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
    <div class="account-settings-info-view">
      <a-row :gutter="16" type="flex" justify="center">
        <a-col :md="24" :lg="16">
          <a-form :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配置片区">
              <a-tree-select :tree-data="treeData" v-model="addOrUpdateForm.zoneId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                treeNodeFilterProp="title"></a-tree-select>
            </a-form-item>
            <a-form-item>
              <a-button style="margin-left:200px" type="primary" :loading="confirmLoading"
                @click="updateData">更新大屏配置</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'LargeScreenDisplay',
  components: {},
  data () {
    return {
      list: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
      },
      treeDefaultExpandedKeys: [],
      addOrUpdateForm: {
        zoneId: null
      },
      listUrl: '/zone-metering/zone-metering/tree',
      largeUrl: '/pipe-network/large/screen'
    }
  },
  computed: {
    treeData () {
      return this.filterTree(this.list, this.currentId)
    },
  },
  methods: {
    getDataList () {
      this.$http.get(this.listUrl).then(res => {
        console.log('res', res);
        this.list = res.data
      })
      this.$http.get(this.largeUrl).then(res => {
        this.addOrUpdateForm.zoneId = res.data.zoneId
      })
    },
    filterTree (list, id) {
      if (id && list) {
        let realList = []
        realList = list.map((l) => {
          return {
            ...l,
            selectable: l.id !== id,
            children: l.id === id ? this.filterTreetoSelected(l.children) : this.filterTree(l.children, id)
          }
        })
        return realList
      } else {
        return list
      }
    },
    filterTreetoSelected (list) {
      if (list) {
        return list.map((l) => ({ ...l, selectable: false, children: this.filterTreetoSelected(l.children) }))
      } else {
        return list
      }
    },
    //更新数据
    updateData () {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          let params = Object.assign(values)
          this.$http
            .post(this.largeUrl, this.addOrUpdateForm)
            .then(res => {
              console.log('res', res);
              if (res.code == 0) {
                this.$message.success(res.message)
                this.getDataList()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
              console.log('失败');
            })
        }
      })
    }
  },
  created () {
    this.getDataList()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
